<script setup>
import useInStorageTable from "./hooks/useRequisitionTable";
import Adjust from "./adjust.vue";
import { PROCESS_STATUS, TAG_TYPE, PIAO_STATUS } from "@/constants";
import useStashList from "../../hooks/useStashList";
import { onMounted, ref, reactive } from "vue";
import { queryDictList } from "@/api/dict";
import { DICT_KEY } from "@/constants/dict";
import { queryOrganization } from "@/api/organization";
import { importBoundPicking } from "@/api/bound";
const { stashList } = useStashList();

// 申请类型列表
const typeList = ref([]);

const defaultPropsOrg = reactive({
  label: "organizationName",
});

//组织
const orgTree = ref([]);

//获取组织
const getOrg = () => {
  queryOrganization().then((res) => {
    if (JSON.stringify(res.data) != "{}") {
      orgTree.value = res.data || [];
    }
  });
};

const {
  searchRef,
  searchData,
  columns,
  tableData,
  statistics,
  tableLoading,
  pages,
  handleSizeChange,
  handleCurrentChange,
  editRef,
  datePicker,
  tableRef,
  handleReset,
  getList,
  handleAdjust,
  handleExport,
  datePickerChange,
  handleSelectionChange,
  handleBatchDelete,
  cancerMarkers,
  markers,
  handleProcess,
  handleUpload,
  uploadRef,
  uploadConfig,
} = useInStorageTable();

onMounted(() => {
  getList();
  getOrg();
  queryDictList(DICT_KEY["boundAcceptMaterial"]).then((res) => {
    typeList.value = res.data || [];
  });
});
</script>

<template>
  <zh-table-page v-bind="{ title: '领料申请' }">
    <template #header-btn
      ><el-button type="primary" icon="Plus" @click="handleAdjust(null, '0')"
        >新增</el-button
      ></template
    >
    <template #search>
      <el-form :model="searchData" ref="searchRef" label-width="90px">
        <el-row :gutter="10">
          <el-col :span="5">
            <el-form-item label="申请单号：" prop="number">
              <el-input v-model="searchData.number" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="申请人" prop="type">
              <el-input
                v-model="searchData.boundUserName"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="申请时间：">
              <el-date-picker
                v-model="datePicker"
                type="datetimerange"
                placeholder="请选择"
                style="width: 100%"
                @change="datePickerChange"
                format="YYYY-MM-DD HH:mm:ss"
                value-format="YYYY-MM-DD HH:mm:ss"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="申请部门" prop="requestDepartmentId">
              <el-tree-select
                v-model="searchData.requestDepartmentId"
                :data="orgTree"
                placeholder="请选择申请部门"
                :props="defaultPropsOrg"
                :show-checkbox="true"
                :check-strictly="true"
                node-key="organizationCode"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="物料用途" prop="type">
              <el-select
                v-model="searchData.type"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="item in typeList"
                  :key="item.id"
                  :label="item.dictLabel"
                  :value="String(item.dictValue)"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="审核状态" prop="processStatus">
              <el-select
                v-model="searchData.processStatus"
                placeholder="请选择"
                style="width: 90%"
              >
                <el-option
                  v-for="item in PROCESS_STATUS"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>
    <template #table>
      <!-- <el-button icon="Delete" @click="handleBatchDelete(null, true)"
        >批量删除</el-button
      > -->
      <el-button icon="Upload" @click="handleUpload()">导入</el-button>
      <el-button icon="Download" @click="handleExport()">导出</el-button>
      <el-button @click="handleBatchDelete(null, true)">批量删除</el-button>
      <el-button type="primary" icon="Search" @click="getList()"
        >查询</el-button
      >
      <el-button icon="Refresh" @click="handleReset()">重置</el-button>

      <div class="total">
        <span>领料申请数: {{ statistics.count || 0 }}</span>
        <span class="price"
          >申请物料总数: {{ statistics.applyQuantity || 0 }} (待审核{{
            statistics.toBeSubmittedApplyQuantity || 0
          }}&nbsp;&nbsp;&nbsp;&nbsp; 审核中{{
            statistics.underApprovalApplyQuantity || 0
          }}&nbsp;&nbsp;&nbsp;&nbsp; 审核通过{{
            statistics.agreeApplyQuantity || 0
          }}&nbsp;&nbsp;&nbsp;&nbsp; 审核不通过{{
            statistics.rejectApplyQuantity || 0
          }})</span
        >
      </div>
      <el-table
        ref="tableRef"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{
          'text-align': 'center',
        }"
        style="width: 100%; margin-top: 10px"
        max-height="520"
        v-loading="tableLoading"
        :data="tableData"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" />
        <template v-for="item in columns" :key="item.prop">
          <el-table-column
            :label="item.label"
            :prop="item.prop"
            :min-width="120"
            show-overflow-tooltip
          >
            <template #default="{ row }">
              <el-tag
                :type="TAG_TYPE[row[item.prop]?.value]"
                v-if="item.prop == 'processStatus'"
                >{{ row[item.prop]?.desc }}</el-tag
              >
              <span v-else>{{ row[item.prop] || "-" }}</span>
            </template>
          </el-table-column>
        </template>
        <el-table-column label="操作" width="150" fixed="right">
          <template #default="{ row }">
            <el-button type="primary" link @click="handleAdjust(row, 2)"
              >查看</el-button
            >
            <el-button
              type="primary"
              link
              @click="handleAdjust(row, 1)"
              v-if="
                row.processStatus.value == 1 || row.processStatus.value == 4
              "
              >编辑</el-button
            >
            <el-button
              type="danger"
              link
              @click="handleBatchDelete(row.id, false)"
              v-if="
                row.processStatus.value == 1 || row.processStatus.value == 4
              "
              >删除</el-button
            >
            <el-button
              type="danger"
              link
              @click="handleProcess(row.approvalId, false)"
              v-if="
                row.processStatus.value == 1 || row.processStatus.value == 4
              "
              >提交审核</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="pages.total > 0"
        background
        style="margin-top: 10px"
        :current-page="pages.page"
        :page-size="pages.size"
        :page-sizes="[10, 20, 30, 50]"
        :total="pages.total"
        layout="->, total, prev, pager, next, sizes, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </template>
  </zh-table-page>
  <!-- 新增入库 -->
  <Adjust ref="editRef" @after-save="getList" />

  <!-- 导入组件 -->
  <FileUpload
    ref="uploadRef"
    @afterUpload="getList"
    :fn="importBoundPicking"
    :uploadConfig="uploadConfig"
  />
</template>

<style lang="less" scoped>
.total {
  display: inline-block;
  color: #409eff;
  margin-left: 20px;
  font-size: 12px;
  .price {
    margin-left: 20px;
  }
}
</style>
